module.exports = __webpack_public_path__ + "static/media/14.99492839.jpg";